// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_Aqypg","checkboxError":"ItV6ZE"};